import { mtApi } from 'api'

export interface VisibilityUser {
  email: string
  firstname: string
  id: string
  image: string | null
  isWhitelisted: boolean
  lastname: string
}

export interface FetchVisibilityUsersResponse {
  count: number
  records: VisibilityUser[]
  total: number
}

export interface VisibilityUsersParams {
  search: string
  page: number
  limit: number
}

export const fetchVisibilityUsers = ({ search, page, limit }: VisibilityUsersParams) =>
  mtApi.get<FetchVisibilityUsersResponse>('/users/me/visibility-users', {
    params: {
      search,
      page,
      limit,
    },
  })
